import api from './api'

const ROOT = '/tpm/admin'

export const tpmApi = {
  listDevices: (status) =>
    api.get(`${ROOT}/devices`, { params: status ? { status } : undefined }).then((r) => r.data),

  getDevice: (deviceId) =>
    api.get(`${ROOT}/devices/${deviceId}`).then((r) => r.data),

  getDeviceHistory: (deviceId) =>
    api.get(`${ROOT}/devices/${deviceId}/history`).then((r) => r.data),

  changeStatus: (deviceId, newStatus, reason) =>
    api
      .post(`${ROOT}/devices/${deviceId}/status`, { newStatus, reason })
      .then((r) => r.data),

  listPending: () => api.get(`${ROOT}/pending`).then((r) => r.data),

  approve: (requestId, note) =>
    api.post(`${ROOT}/pending/${requestId}/approve`, { note }).then((r) => r.data),

  deny: (requestId, note) =>
    api.post(`${ROOT}/pending/${requestId}/deny`, { note }).then((r) => r.data),
}

export const DeviceTpmStatus = {
  Produced: 0,
  Enrolled: 1,
  Active: 2,
  Suspended: 3,
  Revoked: 4,
  Decommissioned: 5,
}

export const deviceStatusLabel = (status) => {
  if (typeof status === 'string') return status
  const map = {
    0: 'Produzido',
    1: 'Enrolled',
    2: 'Ativo',
    3: 'Suspenso',
    4: 'Revogado',
    5: 'Descomissionado',
  }
  return map[status] ?? `desconhecido (${status})`
}

export const deviceStatusColor = (status) => {
  const s = typeof status === 'string' ? status : deviceStatusLabel(status)
  switch (s) {
    case 'Ativo':
    case 'Active':
      return 'bg-green-100 text-green-800'
    case 'Enrolled':
      return 'bg-blue-100 text-blue-800'
    case 'Produzido':
    case 'Produced':
      return 'bg-gray-100 text-gray-800'
    case 'Suspenso':
    case 'Suspended':
      return 'bg-amber-100 text-amber-800'
    case 'Revogado':
    case 'Revoked':
    case 'Descomissionado':
    case 'Decommissioned':
      return 'bg-red-100 text-red-800'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}
